var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1632 6.46498C18.83 9.13178 18.83 13.4956 16.1632 16.1624C13.4964 18.8292 9.13252 18.8292 6.46572 16.1624C3.79892 13.4956 3.79892 9.13178 6.46572 6.46498C9.13252 3.79817 13.4964 3.79817 16.1632 6.46498ZM16.9713 5.65685C13.86 2.54558 8.76887 2.54558 5.6576 5.65685C2.54633 8.76812 2.54633 13.8593 5.6576 16.9706C8.76887 20.0818 13.86 20.0818 16.9713 16.9706C20.0826 13.8593 20.0826 8.76812 16.9713 5.65685Z",
    fill: "#0B3A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.951 14.1425L12.1226 11.3141L14.951 8.48567L14.1429 7.67755L11.3145 10.506L8.48603 7.67755L7.6779 8.48567L10.5063 11.3141L7.6779 14.1425L8.48603 14.9506L11.3145 12.1222L14.1429 14.9506L14.951 14.1425Z",
    fill: "#0B3A5A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenu);
export default __webpack_public_path__ + "static/media/closeMenu.9ffe40ea8e0788eb69e7e934f5ca8c1f.svg";
export { ForwardRef as ReactComponent };